import { AreaPath } from './AreaPath';
import { CustomQuery } from './CustomQuery';
import { DisplayColumns } from './DisplayColumns';

export class UserContext {
  displayName: string;
  givenName: string;
  lastName: string;
  email: string;
  persona: string;
  hasTeam: boolean;
  flights: string[];
  displayColumns: DisplayColumns;
  views: CustomQuery[];
  // TODO: Create User Settings Object
  userSettings: any;
  isUserExcluded: string;
  isUserInOrg: string;
  areapaths: AreaPath[];
  authorization: AuthorizationResponse;
}

export class UserContact {
  displayName: string;
  email: string;
  businessPhone: string[];
  officeLocation: string;
  department: string;
  jobTitle: string;
  displayPicture: any;
}

export class UserManager {
  displayName: string;
  email: string;
  businessPhone: string[];
  officeLocation: string;
  jobTitle: string;
  displayPicture: any;
}
export class TenantAuthorization {
  Tenant: string;
  TenantID: string;
  Platform: string;
  Workspace: any;
  WorkspaceID: any;
  IsPrivateWorkspace: boolean;
  IsDoDHard: boolean;
  AreaPaths: any[];
  CustomParameters: any;
  RoleScopeMap: RoleScope[];
}

export class RoleScope {
  Role: string;
  Scopes: string[];
  DisplayFields: any[];
  EditableFields: any[];
  Permissions: any[];
}

export class AuthorizationResponse {
  TenantAuthorizations: TenantAuthorization[];
}
